(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["g6-he-details"] && !Shopify.designMode) return;
  try {
    
function enableG6ClientVariants(){if(!document.querySelector('.g6-details'))return;document.querySelectorAll('variant-picker').forEach(picker=>{const data=picker.querySelector('script[type="application/json"]');if(!data)return;let product;try{product=JSON.parse(data.textContent).product}catch(e){return}if(String(product?.id)!=='15428515135666')return;picker.dataset.clientVariantUpdates='true';picker.clientVariantUpdates=true;});}customElements.whenDefined('variant-picker').then(enableG6ClientVariants);document.addEventListener('shopify:section:load',enableG6ClientVariants);

function bindG6Tabs(root){root.querySelectorAll('.g6-detail--tabs').forEach(article=>{if(article.dataset.g6Bound)return;article.dataset.g6Bound='true';article.querySelectorAll('[data-g6-tab]').forEach(button=>button.addEventListener('click',()=>{article.querySelectorAll('[data-g6-tab]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));article.querySelectorAll('[data-g6-tab-panel]').forEach(panel=>panel.hidden=panel.dataset.g6TabPanel!==button.dataset.g6Tab);}));});}bindG6Tabs(document);document.addEventListener('shopify:section:load',event=>bindG6Tabs(event.target));

  } catch(e) { console.error(e); }
})();
})();
